export const TEST_CREDENTIALS = [
  { user: 'admin', userLevel: '0' },
  { user: 'user', userLevel: '1' },
] as const;

/** REST auth-login mock when VITE_TEST_MODE — keep in sync with e2e/helpers/auth.ts */
export const E2E_REST_AUTH = {
  email: 'admin',
  password: 'password',
} as const;

export const DEVICE_TYPE: string = '4GE20FE';

export function getPartNumber(): string {
  if (DEVICE_TYPE === '2GE8FE') return '006-130-120';
  if (DEVICE_TYPE === '4GE12FE') return '006-130-124';
  if (DEVICE_TYPE === '4GE20FE') return '006-130-140';
  return '006-130-120';
}

export const FILES_LIST = [
  {
    name: 'config.cfg',
    size: '2048',
    url: 'http://192.168.1.1/config.cfg',
    date: '2024-01-15 10:30:00',
    type: 'config',
  },
  {
    name: 'backup.cfg',
    size: '2048',
    url: 'http://192.168.1.1/backup.cfg',
    date: '2024-01-14 15:45:00',
    type: 'backup',
  },
  {
    name: 'firmware.bin',
    size: '8192',
    url: 'http://192.168.1.1/firmware.bin',
    date: '2024-01-10 09:20:00',
    type: 'firmware',
  },
];
